export const visit = (vm, at) => {
at({ "en": { "composer-ui": { "macros-menu": { "title": "Macros", "no-macros": "No macros have been created by your admin yet. Please reach out to them for assistance.", "error-state": "Macros couldn't be loaded. Please try again later." } } } });
};